import React from 'react';
import { Container } from 'react-bootstrap';

import Particle from '../components/Particle';
import Educationn from '../components/Experience/Edu';
import Experiencee from '../components/Experience/Exp';

const Experience = () => {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="yellow">Experience</strong>
        </h1>
        <Experiencee />
        <h1 className="project-heading">
          <strong className="yellow">Education</strong>
        </h1>

        <Educationn />
        <h1 className="project-heading">
          <strong className="yellow">Certification</strong> and Achievements
        </h1>
        <p style={{ paddingBottom: '10px' }}>
          Comming <strong className="yellow">Soon!</strong>
        </p>
        {/* <Certi /> */}
      </Container>
    </Container>
  );
};

export default Experience;
